import {
  type HistoryGroup,
  getHistoryId,
  getOrderStatusUpdate,
  isHistoryGroup,
} from "@/features/history/utils";
import { useModals } from "@/features/modals/hooks";
import { type History } from "@repo/api";
import { LightMode, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { SimpleLabelField } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface Props {
  history: History | HistoryGroup;
}

const QuotationHistoryListItem = ({
  history,
}: {
  history: History | HistoryGroup;
}) => {
  const orderStatusUpdate = getOrderStatusUpdate(history);
  const showBody = !orderStatusUpdate;

  return (
    <div>
      {showBody && <Text textStyle="Body.S">{history.body}</Text>}
      <Text textStyle="Body.S">{history.note}</Text>
      {history.details?.quotation_id && (
        <SimpleLabelField
          small
          label={t("label.quotation_id")}
          value={history.details.quotation_id}
          color={LightMode.colourTextAndIcon2}
        />
      )}
      {orderStatusUpdate && <Text>{orderStatusUpdate}</Text>}
    </div>
  );
};

export const QuotationHistoryItem = ({ history }: Props) => {
  const { pushModal } = useModals();

  const historyEntries = isHistoryGroup(history)
    ? history.prevEntries
    : undefined;
  const entryId = history.details?.quotation_id ?? getHistoryId(history);

  return (
    <HistoryListViewItem
      history={history}
      control={entryId ? "navigational" : "default"}
      onClick={() => {
        if (entryId) {
          pushModal({
            type: "QUOTATION",
            quotationId: entryId,
            historyEntries,
          });
        }
        trackAnalytics("order_history");
      }}
      title={history.title}
      description={<QuotationHistoryListItem history={history} />}
    />
  );
};
